<template>
  <div>
    <b-carousel
      id="carousel-2"
      v-model="slide"
      :interval="4000"
      controls
      indicators      
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
  >
  <b-carousel-slide caption="" :img-src="require('@/assets/galeria/1.jpg')"></b-carousel-slide>
	<b-carousel-slide caption="" :img-src="require('@/assets/galeria/2.jpg')"></b-carousel-slide>
	<b-carousel-slide caption="" :img-src="require('@/assets/galeria/3.jpg')"></b-carousel-slide>
	<b-carousel-slide caption="" :img-src="require('@/assets/galeria/4.jpg')"></b-carousel-slide>
	<b-carousel-slide caption="" :img-src="require('@/assets/galeria/5.jpg')"></b-carousel-slide>
	<b-carousel-slide caption="" :img-src="require('@/assets/galeria/6.jpg')"></b-carousel-slide>
	<b-carousel-slide caption="" :img-src="require('@/assets/galeria/7.jpg')"></b-carousel-slide>
	<b-carousel-slide caption="" :img-src="require('@/assets/galeria/8.jpg')"></b-carousel-slide>
	<b-carousel-slide caption="" :img-src="require('@/assets/galeria/9.jpg')"></b-carousel-slide>
	<b-carousel-slide caption="" :img-src="require('@/assets/galeria/10.jpg')"></b-carousel-slide>
	<b-carousel-slide caption="" :img-src="require('@/assets/galeria/11.jpg')"></b-carousel-slide>
    
  </b-carousel>
  </div>
</template>

<style>
#carousel-2 {
    text-shadow: 1px 1px 2px #333;
    height: auto !important;
    min-height: auto !important;
    overflow-y: hidden;
    text-shadow: rgb(51, 51, 51) 1px 1px 2px !important;
}

#carousel-2 div div::before {
    content: '';
    left: 0;
    right: 0;
    height: 100vh;
    min-height: 650px;
    width: 100%;
    background: linear-gradient(
90deg
, rgba(0,0,0,.0) 0%, rgba(0,0,0,0) 0%);
    position: absolute;
}
</style>

<script>
  export default {
    data() {
      return {
        sliders: [],
        sliding: null
      }
    },
    methods: {
      onSlideStart() {
        this.sliding = true
      },
      onSlideEnd() {
        this.sliding = false
      }
    }
  }
</script>